// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__1se4a","disabled":"FileBtn_disabled__1kILQ","warn":"FileBtn_warn__ASl_q","fade":"FileBtn_fade__3U2P6"};